import React, { useState } from "react";
import Cropper from "react-easy-crop";
import { Button, Icon, Label } from "semantic-ui-react";
import usePhoto from "../hooks/usePhoto";
import getCroppedImg from "../helpers/image";

const ImageCrop = ({ image }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);

  const { croppedAreaPixels, setPhotoState, toggleCropper } = usePhoto();

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setPhotoState({ croppedAreaPixels });
  };

  const saveCroppedImage = async () => {
    try {
      const photo = await getCroppedImg(image, croppedAreaPixels, rotation);
      toggleCropper(false);
      setPhotoState({ photo, updatePhoto: true });
    } catch (e) {
      console.error(e);
    }
  };

  const onClose = () => {
    toggleCropper(false);
    setPhotoState({ updatePhoto: false });
  };

  return (
    <div className="crop-container">
      <div className="cropper">
        <Cropper
          image={image}
          crop={crop}
          rotation={rotation}
          zoom={zoom}
          aspect={1 / 1}
          onCropChange={setCrop}
          onRotationChange={setRotation}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
        />
      </div>
      <div className="control flex gap-1">
        <div className="flex-between">
          <Label horizontal>ZOOM</Label>
          <input
            type="range"
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={(e) => {
              setZoom(e.target.value);
            }}
          />
        </div>
        <div className="flex-between">
          <Label horizontal>ROTATION</Label>
          <input
            type="range"
            value={rotation}
            min={0}
            max={360}
            step={1}
            aria-labelledby="Rotation"
            onChange={(e) => {
              setRotation(e.target.value);
            }}
          />
        </div>
        <div className="flex-between">
          <Button type="button" color="blue" onClick={saveCroppedImage}>
            Submit
          </Button>
          <Button type="button" color="red" onClick={onClose}>
            <Icon name="arrow left" />
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ImageCrop;
